/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import Styles from "../../Reports/Components/OrganizationStructureNew/OrganizationStructure.styles";
import AutoCompleteDropdown from "../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import { SERVICES } from "../../../components/Layout/Services";
import { get } from "../../../components/Layout/ApiHandler/apihandler";

export const isEmptyObj = (obj) => Boolean(!obj || !Object.keys(obj).length);
export const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));
export const ORGANIZATION_STRUCTURE_FIELDS = {
  AREA: "areaId",
  CLUSTER: "clusterId",
  ZONE: "zoneId",
  REGION: "regionId",
  CHAPTER: "chapterId",
  DISTRICT: "districtId",
  BLOCK: "blockId",
};
function OrganizationStructure({
  clearValues,
  onUpdateValues,
  initialAreaId,
  setNameValues,
}) {
  const [area, setArea] = useState([]);
  const [cluster, setCluster] = useState([]);
  const [zone, setZone] = useState([]);
  const [region, setRegion] = useState([]);
  const [chapter, setChapter] = useState([]);
  const [district, setDistrict] = useState([]);
  const [block, setBlock] = useState([]);
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({
    [ORGANIZATION_STRUCTURE_FIELDS.AREA]: null,
    [ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]: null,
    [ORGANIZATION_STRUCTURE_FIELDS.ZONE]: null,
    [ORGANIZATION_STRUCTURE_FIELDS.REGION]: null,
    [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: null,
    [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: null,
    [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: null,
  });
  const [areaName, setAreaName] = useState("");
  const [clusterName, setClusterName] = useState("");
  const [zoneName, setZoneName] = useState("");
  const [regionName, setRegionName] = useState("");
  const [chapterName, setChapterName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const getArea = async () => {
    try {
      const url = `${SERVICES.AREA}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setArea(data.data);
      } else {
        console.error("Failed to fetch data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getCluster = async (areaId) => {
    // console.log("areaId:", areaId);
    if (areaId) {
      try {
        const url = `${SERVICES.CLUSTER}?areaId=${areaId}`;
        const response = await get(url);
        if (response.ok) {
          const data = await response.json();
          setCluster(data.data);
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  };
  const getZone = async (clusterId) => {
    // console.log("areaId:", areaId);
    if (clusterId) {
      try {
        const url = `${SERVICES.ZONE}?clusterId=${clusterId}`;
        const response = await get(url);
        if (response.ok) {
          const data = await response.json();
          setZone(data.data);
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  };
  const getRegion = async (zoneId) => {
    if (zoneId) {
      try {
        const url = `${SERVICES.REGION}?zoneId=${zoneId}`;
        const response = await get(url);
        if (response.ok) {
          const data = await response.json();
          setRegion(data.data);
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  };
  const getChapter = async (regionId) => {
    if (regionId) {
      try {
        const url = `${SERVICES.CHAPTER}?regionId=${regionId}`;
        const response = await get(url);
        if (response.ok) {
          const data = await response.json();
          setChapter(data.data);
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  };
  const getDistrict = async (chapterId) => {
    if (chapterId) {
      try {
        const url = `${SERVICES.DISTRICT}?chapterId=${chapterId}`;
        const response = await get(url);
        if (response.ok) {
          const data = await response.json();
          setDistrict(data.data);
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  };
  const getBlock = async (districtId) => {
    if (districtId) {
      try {
        const url = `${SERVICES.BLOCK}?districtId=${districtId}`;
        const response = await get(url);
        if (response.ok) {
          const data = await response.json();
          setBlock(data.data);
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    }
  };
  const updateValues = () => {
    onUpdateValues(values);
  };
  useEffect(() => {
    getArea();
    if (initialAreaId) {
      setValues((prevValues) => ({
        ...prevValues,
        [ORGANIZATION_STRUCTURE_FIELDS.AREA]: initialAreaId,
      }));
    }
  }, [initialAreaId]);
  useEffect(() => {
    // getArea();
    getCluster();
    getZone();
    getRegion();
    getChapter();
    getDistrict();
    getBlock();
  }, []);
  useEffect(() => {
    updateValues();
  }, [values, onUpdateValues]);
  useEffect(() => {
    // handlePaymentMethod();
    setNameValues((prevValues) => ({
      ...prevValues,
      areaName: areaName || "",
      clusterName: clusterName || "",
      zoneName: zoneName || "",
      regionName: regionName || "",
      chapterName: chapterName || "",
      districtName: districtName || "",
      blockName: blockName || "",
    }));
  }, [
    areaName,
    clusterName,
    zoneName,
    regionName,
    chapterName,
    districtName,
    blockName,
  ]);
  useEffect(() => {
    if (clearValues) {
      setValues({
        [ORGANIZATION_STRUCTURE_FIELDS.AREA]: null,
        [ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]: null,
        [ORGANIZATION_STRUCTURE_FIELDS.ZONE]: null,
        [ORGANIZATION_STRUCTURE_FIELDS.REGION]: null,
        [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: null,
        [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: null,
        [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: null,
      });
    }
  }, [clearValues]);
  useEffect(() => {
    if (queryParams.get("areaId") === null) {
      setValues((prevValues) => ({
        ...prevValues,
        [ORGANIZATION_STRUCTURE_FIELDS.AREA]: null,
      }));
    }
    if (queryParams.get("clusterId") === null) {
      setValues((prevValues) => ({
        ...prevValues,
        [ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]: null,
      }));
    }
    if (queryParams.get("zoneId") === null) {
      setValues((prevValues) => ({
        ...prevValues,
        [ORGANIZATION_STRUCTURE_FIELDS.ZONE]: null,
      }));
    }
    if (queryParams.get("regionId") === null) {
      setValues((prevValues) => ({
        ...prevValues,
        [ORGANIZATION_STRUCTURE_FIELDS.REGION]: null,
      }));
    }
    if (queryParams.get("chapterId") === null) {
      setValues((prevValues) => ({
        ...prevValues,
        [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: null,
      }));
    }
    if (queryParams.get("districtId") === null) {
      setValues((prevValues) => ({
        ...prevValues,
        [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: null,
      }));
    }
    if (queryParams.get("blockId") === null) {
      setValues((prevValues) => ({
        ...prevValues,
        [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: null,
      }));
    }
  }, [
    queryParams.get("areaId"),
    queryParams.get("clusterId"),
    queryParams.get("zoneId"),
    queryParams.get("regionId"),
    queryParams.get("chapterId"),
    queryParams.get("districtId"),
    queryParams.get("blockId"),
  ]);
  return (
    <Grid
      container
      style={{
        // border: "1px solid #C4C4C4",
        // padding: 20,
        display: "flex",
        flexWrap: "nowrap",
        // gap: "2px",
        border: "none",
        padding: 0,
        flexDirection: "column",
        // ...(containerStyle ?? {}),
      }}
    >
      <Grid item md={12} xs={12} style={Styles.gridStyle}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          name={ORGANIZATION_STRUCTURE_FIELDS.AREA}
          options={getOptions(area, "structureId")}
          error={errors[ORGANIZATION_STRUCTURE_FIELDS.AREA]}
          value={values[ORGANIZATION_STRUCTURE_FIELDS.AREA]}
          label="Area"
          onChange={(selectedValue) => {
            setAreaName(selectedValue?.name);
            const selectedAreaId = selectedValue
              ? selectedValue.structureId
              : null;
            setValues((prevValues) => ({
              ...prevValues,
              [ORGANIZATION_STRUCTURE_FIELDS.AREA]: selectedValue
                ? selectedValue.value
                : null,
            }));
            // If area is removed, clear all subsequent values
            if (!selectedValue) {
              setValues({
                [ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.ZONE]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.REGION]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: null,
              });
              setCluster([]);
              setZone([]);
              setRegion([]);
              setChapter([]);
              setDistrict([]);
              setBlock([]);
              return;
            }
            // Fetch zone data based on the selected area
            getCluster(selectedAreaId);
          }}
        />
      </Grid>
      <Grid item md={12} xs={12} style={Styles.gridStyle}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          name={ORGANIZATION_STRUCTURE_FIELDS.CLUSTER}
          options={getOptions(cluster, "structureId")}
          error={errors[ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]}
          value={values[ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]}
          label="Cluster"
          onChange={(selectedValue) => {
            setClusterName(selectedValue?.name);
            const selectedClusterId = selectedValue
              ? selectedValue.structureId
              : null;
            setValues((prevValues) => ({
              ...prevValues,
              [ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]: selectedValue
                ? selectedValue.value
                : null,
            }));
            if (!selectedValue) {
              setValues({
                [ORGANIZATION_STRUCTURE_FIELDS.ZONE]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.REGION]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: null,
              });
              setZone([]);
              setRegion([]);
              setChapter([]);
              setDistrict([]);
              setBlock([]);
              return;
            }
            getZone(selectedClusterId);
          }}
        />
      </Grid>
      <Grid item md={12} xs={12} style={Styles.gridStyle}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          name={ORGANIZATION_STRUCTURE_FIELDS.ZONE}
          options={getOptions(zone, "structureId")}
          error={errors[ORGANIZATION_STRUCTURE_FIELDS.ZONE]}
          value={values[ORGANIZATION_STRUCTURE_FIELDS.ZONE]}
          label="Zone"
          onChange={(selectedValue) => {
            setZoneName(selectedValue?.name);
            const selectedZoneId = selectedValue
              ? selectedValue.structureId
              : null;
            setValues((prevValues) => ({
              ...prevValues,
              [ORGANIZATION_STRUCTURE_FIELDS.ZONE]: selectedValue
                ? selectedValue.value
                : null,
            }));
            if (!selectedValue) {
              setValues({
                [ORGANIZATION_STRUCTURE_FIELDS.REGION]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: null,
              });
              setRegion([]);
              setChapter([]);
              setDistrict([]);
              setBlock([]);
              return;
            }
            getRegion(selectedZoneId);
          }}
        />
      </Grid>
      <Grid item md={12} xs={12} style={Styles.gridStyle}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          name={ORGANIZATION_STRUCTURE_FIELDS.REGION}
          options={getOptions(region, "structureId")}
          error={errors[ORGANIZATION_STRUCTURE_FIELDS.REGION]}
          value={values[ORGANIZATION_STRUCTURE_FIELDS.REGION]}
          label="Region"
          onChange={(selectedValue) => {
            setRegionName(selectedValue?.name);
            const selectedRegionId = selectedValue
              ? selectedValue.structureId
              : null;
            setValues((prevValues) => ({
              ...prevValues,
              [ORGANIZATION_STRUCTURE_FIELDS.REGION]: selectedValue
                ? selectedValue.value
                : null,
            }));
            if (!selectedValue) {
              setValues({
                [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: null,
              });
              setChapter([]);
              setDistrict([]);
              setBlock([]);
              return;
            }
            getChapter(selectedRegionId);
          }}
        />
      </Grid>
      {/* <Grid item md={12} xs={12} style={Styles.gridStyle}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          name={ORGANIZATION_STRUCTURE_FIELDS.CHAPTER}
          options={getOptions(chapter, "structureId")}
          error={errors[ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]}
          value={values[ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]}
          label="Chapter"
          onChange={(selectedValue) => {
            setChapterName(selectedValue?.name);
            const selectedChapterId = selectedValue
              ? selectedValue.structureId
              : null;
            setValues((prevValues) => ({
              ...prevValues,
              [ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]: selectedValue
                ? selectedValue.value
                : null,
            }));
            if (!selectedValue) {
              setValues({
                [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: null,
                [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: null,
              });
              setDistrict([]);
              setBlock([]);
              return;
            }
            getDistrict(selectedChapterId);
          }}
        />
      </Grid> */}
      {/* <Grid item md={12} xs={12} style={Styles.gridStyle}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          name={ORGANIZATION_STRUCTURE_FIELDS.DISTRICT}
          options={getOptions(district, "structureId")}
          error={errors[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
          value={values[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
          label="District"
          onChange={(selectedValue) => {
            setDistrictName(selectedValue?.name);
            const selectedDistrictId = selectedValue
              ? selectedValue.structureId
              : null;
            setValues((prevValues) => ({
              ...prevValues,
              [ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]: selectedValue
                ? selectedValue.value
                : null,
            }));
            if (!selectedValue) {
              setValues({
                [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: null,
              });
              setBlock([]);
              return;
            }
            getBlock(selectedDistrictId);
          }}
        />
      </Grid> */}
      {/* <Grid item md={12} xs={12} style={Styles.gridStyle}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          name={ORGANIZATION_STRUCTURE_FIELDS.BLOCK}
          options={getOptions(block, "structureId")}
          error={errors[ORGANIZATION_STRUCTURE_FIELDS.BLOCK]}
          value={values[ORGANIZATION_STRUCTURE_FIELDS.BLOCK]}
          label="Block"
          onChange={(selectedValue) => {
            setBlockName(selectedValue?.name);
            setValues((prevValues) => ({
              ...prevValues,
              [ORGANIZATION_STRUCTURE_FIELDS.BLOCK]: selectedValue
                ? selectedValue.value
                : null,
            }));
          }}
        />
      </Grid> */}
    </Grid>
  );
}
export default OrganizationStructure;
